import type { IProp as IPropSchema } from '../repositories/offers-comparison/entities/props/Prop';
import type { IProp, TProps } from '../types/redux/props';
import type { TCompareType } from '../types/compareType';
import { EFieldGroupName, EFieldName } from '../types/field';

export function prepareProps(props: IPropSchema[], compareType: TCompareType): Partial<TProps> {
  return {
    [compareType]: props.map(prop => {
      const preparedProp: IProp = {
        ...prop,
        items: prop.items.map(item => ({ ...item, name: item.name as unknown as EFieldName })),
        name: prop.name as unknown as EFieldGroupName,
      };

      return preparedProp;
    }),
  };
}
